/**
 * @desc 获取实例历史任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<defs.activiti.HistoricActivityInstanceDto>;
export function request(
  params: API.activiti.business.getHistoryInstance.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/business/historyInstance`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
